core.constant('visitTranslationPL', {
  "T": {
    "SYSTEM": {
      "ERROR": {
        "VISIT_CARD_NOT_FILLED_OUT_ALL_REQUIRED_FIELDS": "Wystąpił błąd podczas zakańczania wizyty! Uzupełnij wszystkie wymagane pola!"
      }
    },
    "UI": {
      "VISIT_HEADER": {
        "CONTROL_VISIT" : "Wizyta kontrolna",
        "PLANNED": "Zaplanowana",
        "TOOK_PLACE": "Odbyła się"
      }
    },
    "MODULE": {
      "VISIT": {
        "MEDICAL_TEMPLATES": {
          "PRESCRIPTION_RP": "Recepta Rp",
          "PRESCRIPTION_RPW":  "Recepta Rpw",
          "PRESCRIPTION_RCP":  "Recepta Rcp",
          "E_REFERRAL": "eSkierowanie",
          "REFERRAL_SPECIALIST": "Skierowanie do specjalisty",
          "REFERRAL_HOSPITAL": "Skierowanie do szpitala",
          "REFERRAL_DIAGNOSTIC": "Skierowanie do pracowni diagnostycznej",
          "REFERRAL_LABORATORY": "Skierowanie na badania laboratoryjne",
          "REFERRAL_LABORATORY_FOR_NOT_PHYSICIANS": "Zalecenie badania laboratoryjnego",
          "REFERRAL_ALAB": "Skierowanie ALAB",
          "REFERRAL_GENERAL": "Skierowanie (druk ogólny)",
          "SICK_LEAVE": "Zwolnienie lekarskie",
          "HEALTH_CARE_CONSENT": "Zgoda na świadczenie usług zdrowotnych",
          "MEDICAL_FILES_PICK_UP_AUTHORIZATION": "Upoważnienie do odbioru dokumentacji medycznej",
          "EWUS_STATEMENT": "Oświadczenie EWUŚ",
          "GENERAL_DOCUMENT": "Dokument ogólny",
          "INSURANCE_STATEMENT_N_9": "Zaświadczenie o stanie zdrowia (druk N9)",
          "INSURANCE_STATEMENT_N_14": "Zaświadczenie o stanie zdrowia (druk N14)"
        },
        "STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT": {
          "WORSE": "Pogorszenie",
          "SAME": "Bez zmian",
          "BETTER": "Poprawa"
        },
        "VISIT_STATUS_FILTER": {
          "NO_FILTER": "Brak filtrów",
          "PLANNED" : "Zaplanowane",
          "IN_PROGRESS": "W trakcie",
          "COMPLETED": "Zakończone",
          "CLOSED": "Zamknięte",
          "CANCELED" : "Anulowana",
          "SUSPENDED": "Do uzupełnienia"
        },
        "ICF_VISIT":"Wizyta ICF",
        "START": "Rozpocznij",
        "CONTINUE": "Kontynuuj",
        "SEND_DOCUMENTATION_TO_P1": "Wyślij dokumentację do P1",
        "EPICRISIS_PREVIEW": "Karta wizyty (podgląd)",
        "SICK_LEAVE": "Zwolnienie lekarskie",
        "MEDICAL_INDICATION": "Wskazanie lekarskie",
        "CORRECT_VISIT_CARD": "Korekta wizyty",
        "FINISH": "Zakończ",
        "FINISH_VISIT": "Zakończ wizytę",
        "VISIT_DETAILS": "Szczegóły wizyty",
        "PLEASE_WAIT_FOR_DOCTOR": "Proszę czekać na połączenie z lekarzem...",
        "PLEASE_WAIT_FOR_PATIENT": "Proszę czekać na połączenie z pacjentem...",
        "DOWNLOAD_VIDEO_CONSULTATION": "Pobierz Video Konsultację",
        "STOP_VIDEO_CONSULTATION": "Zakończ Video Konsultację",
        "GENERATING_VIDEO_CONSULTATION": "Trwa generowanie video",
        "CLINIC": "Placówka",
        "DATE_AND_TIME": "Data i czas",
        "DRUGS": "Leki",
        "OTC_DRUGS": "Leki bez recepty",
        "EPICRISIS" : "Karta wizyty",
        "SHOW_EPIKRYZA" : "Pokaż kartę wizyty",
        "PREVIEW_EPIKRYZA": "Podgląd karty wizyty",
        "SAVE_VISIT": "Zapisz wizytę",
        "SAVE_E_PRESCRIPTION": "Zapisz e-receptę",
        "ENCLOSE_FILE": "Załącz plik",
        "STICK": "Wystaw",
        "INTERVIEW": "Wywiad",
        "RECONNAISSANCE": "Wywiad",
        "SUBJECT_RESEARCH": "Badanie przedmiotowe",
        "PHYSICAL_EXAMINATION": "Badanie przedmiotowe",
        "ICD_10": "Rozpoznanie ICD-10",
        "MAIN_ICD_10": "Rozpoznanie ICD-10 (Główne)",
        "ICD_9": "Procedura ICD-9",
        "CHOOSE_DRUG": "Wybierz lek",
        "WHOLE_YEAR_REALIZATION": "Do realizacji na 365 dni",
        "TREATMENT_DURATION_IN_DAYS": "Liczba dni kuracji",
        "DOCTOR_ORDER": "Zalecenia lekarskie",
        "RECOMMENDATIONS": "Zalecenia",
        "DOCUMENT_LIST": "Lista dokumentow",
        "RECOMMENDED_PRESCRIPTIONS": "Zalecane leki",
        "PRESCRIPTION": "Recepta",
        "E_PRESCRIPTION": "E-recepta",
        "HEART_ECHO": "Echo serca",
        "REFERRAL_TO_CLINIC": "Skierowanie do poradni",
        "MEDICAL_PRIVATE_PRACTICE": "Indywidualna Praktyka Lekarska",
        "REGON": "REGON",
        "PATIENT": "Pacjent",
        "NFZ_BRANCH": "Oddział NFZ",
        "OTHER": "Identyfikator (inny)",
        "ADDITIONAL_PERMISSIONS": "Dodatkowe uprawnienia",
        "PAYMENT": "Odpłatność",
        "DOSAGE": "Dawkowanie",
        "SUMMARY_DOSAGE": "Sumaryczna ilość substancji czynnej (słownie)",
        "COUNT": "Liczba",
        "POST_DATE": "Data wystawienia",
        "REALIZATION_DATE": "Data realizacji \"od dnia\"",
        "INSERT_DATE": "Wprowadź datę",
        "INSERT_ICD": "Wprowadź",
        "RECOGNITIONS": "Rozpoznania",
        "PROCEDURES": "Procedury",
        "INSERT_ICD10_CODE": "Wpisz kod icd10 lub nazwę rozpoznania...",
        "INSERT_ICD9_CODE": "Wpisz kod icd9 lub nazwę procedury...",
        "ENTER_DRUG_NAME": "Wpisz nazwę leku...",
        "B": "B",
        "R": "R",
        "_30": "30%",
        "_50": "50%",
        "_100": "100%",
        "PATIENT_FULL_NAME": "Imię i nazwisko",
        "E_REFERRAL": "e-Skierowanie",
        "DOCUMENTATION_TO_P1_NOT_SENT": "Dokumentacja nie wysłana do P1",
        "SPECIALIST_REFERRAL": "Skierowanie do specjalisty",
        "SPECIALIST_CLINIC_REFERRAL": "Skierowanie do poradni specjalistycznej",
        "CLINIC_NAME": "Nazwa poradni",
        "ASK_FOR": "Proszę o",
        "SPECIALIST_ADVISORY": "Poradę specjalistyczną",
        "SPECIALIST_TREATMENT": "Objęcie leczeniem specjalistycznym",
        "ADDRESS": "Adres",
        "YEARS_OLD": "Lat",
        "COUNSEL_POINT": "Cel porady",
        "PREVIOUS_EXAMINATION": "Dotychczasowe badania",
        "SPECIALIST_CLINIC_NOTES": "Uwagi poradni specjalistycznej",
        "DATE_OF_PATIENT_NOTIFY": "Data zgłoszenia się pacjenta ze skierowaniem",
        "TERM_OF_COUNSEL": "Termin wyznaczonej porady",
        "DOCTOR_SIGNATURE": "Dane i podpis lekarza",
        "SIGNATURE": "Dane i podpis",
        "FOR_MS_OR_MR": "u Pani / Pana",
        "HOSPITAL_REFERRAL": "Skierowanie do szpitala",
        "REDIRECT_MS_OR_MR": "Kieruję Panią / Pana",
        "TO_HOSPITAL_INSTITUTE": "Do szpitala, szpitala klinicznego, instytutu",
        "HOSPITAL_NAME": "Nazwa",
        "IN": "w",
        "HOSPITAL_UNIT": "Oddział",
        "PATIENT_ACCEPTANCE": "Termin uzgodnionego przyjęcia",
        "PHONE": "Telefon",
        "DIAGNOSTIC_CLINIC_REFERRAL": "Skierowanie do pracowni diagnostycznej",
        "ASK_FOR_EXAMINATION": "Proszę o badanie",
        "STUDIO_NAME": "Nazwa pracowni",
        "DIAGNOSTIC_STUDIO_NOTES": "Uwagi pracowni diagnostycznej",
        "TERM_OF_DIAGNOSTIC_EXAMINATION": "Wyznaczony termin badania",
        "EXAMINATION_POINT": "Cel badania",
        "LABORATORY_REFERRAL": "Skierowanie do laboratorium",
        "LABORATORY_CLINIC_REFERRAL": "Skierowanie na badania laboratoryjne",
        "PHONE_NUMBER": "Nr telefonu",
        "DOCUMENT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć dokument?",
        "NO_DIAGNOSIS_ADDED": "Nie dodałeś żadnego rozpoznania",
        "AUTHORIZED_PERSON_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć uprawnioną osobę?",
        "VISIT_TYPE": "Rodzaj wizyty",
        "VISIT_TYPE_2": "Typ wizyty",
        "NEW_VISIT": "Nowa wizyta",
        "EDIT_VISIT": "Edytuj wizytę",
        "INSERT_RCP_DESCRIPTION": "Wprowadź opis receptury",
        "STREET_HEAD": "ul.",
        "VIDEOCONSULTATION": "Wideokonsultacja",
        "VISIT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć wizytę?",
        "CANNOT_OPEN_VISIT_CARD_FOR_THIS_VISIT": "Nie można otworzyć karty dla tej wizyty",
        "INSERT_PRESCRIPTION_DESCRIPTION": "Wprowadź opis receptury.",
        "NOT FILLED": "Nie wypełniono",
        "PREVIEW": "Podgląd",
        "DELETE": "Usuń",
        "PRINT": "Drukuj",
        "NO_ADVISED_DRUGS": "Brak zalecanych leków",
        "NEW_PATIENT": "Nowy pacjent",
        "QUALIFIER": "Kwalifikator",
        "INSERT_ICF_CODE_OR_DESCRIPTION": "Wprowadź kod icf lub opis...",
        "ICF_WISUALIZATION": "Wizualizacja wyników ICF",
        "ICF_CATEGORIES": "Kategorie ICF",
        "ICF_QUALIFIERS": "Kwalifikatory ICF",
        "PROBLEM": "Problem",
        "FACILITATOR": "Ułatwienie",
        "BARRIER": "Bariera",
        "FILL_ALL_QUALIFIERS_TO_SEE_REPORT": "Uzupełnij wszystkie pierwsze kwalifikatory aby zobaczyć raport",
        "FILL_ALL_QUALIFIERS_AND_AT_LEAST_ONE_ICD9_TO_SEE_SIMULATION": "Uzupełnij wszystkie pierwsze kwalifikatory oraz co najmniej jedno procedurę ICD-9 aby zobaczyć symulację",
        "STATE_OF_HEALTH_SIMULATION": "Symulacja stanu zdrowia",
        "ESTIMATE_RISK": "Oszacuj ryzyko",
        "TREATMENT_COST_SIMULATION": "Szacowanie kosztów leczenia",
        "CURRENT_STATE_OF_HEALTH_ABBR": "Stan bieżący",
        "EXPECTED_STATE_OF_HEALTH_ABBR": "Stan przewidywany",
        "SIMULATION_RESULT_ABBR": "Wynik",
        "SUGGESTED_ICD9_PROCEDURES": "Sugerowane procedury ICD9",
        "SELECTED_ICD9_PROCEDURE": "Procedura ICD9 w symulacji",
        "START_SIMULATION": "Uruchom symulację",
        "CHECK_COST": "Sprawdź koszt po zastosowaniu procedur",
        "SHOW_CHART": "Pokaż wykres",
        "BODY_STRUCTURES": "Struktury ciała",
        "BODY_FUNCTIONS": "Funkcje ciała",
        "ENVIRONMENT": "Środowisko",
        "ACTIVITIES_AND_PARTICIPATION": "Aktywność i uczestniczenie",
        "COST_WITHOUT_TREATMENT_ZL": "Koszt bez leczenia [zł]",
        "COST_SIMULATION_ZL": "Symulowany koszt po zastosowaniu procedury [zł]",
        "INSERT_COST": "Podaj koszt...",
        "COST_WITHOUT_TREATMENT": "Koszt bez leczenia",
        "PROCEDURE_COST": "Koszt procedury",
        "ESTIMATED_COST": "Koszt szacowany",
        "ADD_SIMULATION_RESULT_TO_DATA_SET": "Dodaj dane do zestawu uczącego",
        "DRUGS_DOSAGE": "Dawkowanie leków",
        "MORNING": "Rano",
        "AFTERNOON": "Popołudnie",
        "EVENING": "Wieczór",
        "OTHER_NOTES": "Inne uwagi",
        "DETERMINE_DOSAGE": "Określ dawkowanie",
        "LABORATORY_TEST_CATEGORY": "Kategoria badań laboratoryjnych",
        "NEW_LABORATORY_TEST": "Nowe badanie laboratoryjne",
        "NEW_LABORATORY_TEST_CATEGORY": "Nowa kategoria badań laboratoryjnych",
        "NO_PARENT_LABORATORY_TEST_CATEGORY_SELECTED": "Nie wybrano kategorii dla badania laboratoryjnego.",
        "NO_LABORATORY_TEST_CATEGORY_SELECTED": "Podaj nazwę kategorii badania laboratoryjnego.",
        "NO_LABORATORY_TEST_SELECTED": "Podaj nazwę badania laboratoryjnego",
        "LAST_VISIT": "Ostatnia wizyta",
        "RECOGNITION" : "Rozpoznanie",
        "PATIENT_FIRST_VISIT": "Pierwsza wizyta pacjenta",
        "FILL_DATA": "Uzupełnij dane",
        "START_VISIT": "Rozpocznij wizytę",
        "PATIENT_FIRST_VISIT_NEED_TO_FILL_DATA": "Uwaga! Pierwsza wizyta pacjenta, wymagane jest uzupełnienie danych przed przystąpieniem do wizyty.",
        "ALLERGIES": "Uczulenia",
        "PAYER": "Płatnik",
        "ALLERGIES_FOR_DRUGS": "Alergie na leki",
        "CHRONIC_ILLNESSES": "Przewlekłe choroby",
        "DRUGS_TAKEN_CHRONICALLY": "Leki brane przewlekle",
        "FUNCTION_AVAILABLE_AFTER_DRUGS_ADDED": "Funkcja dostępna po przepisaniu leków",
        "ADD_PATIENT": "Dodaj pacjenta",
        "FAVORITE_RECOGNITIONS": "Ulubione rozpoznania",
        "PREVIOUS_RECOGNITIONS": "Poprzednie rozpoznania",
        "NO_FAVORITE_RECOGNITIONS": "Brak ulubionych rozpoznań",
        "NO_FAVORITE_RECOGNITIONS_IN_HISTORY": "Brak rozpoznań w historii",
        "FAVORITE_MEDICAL_PROCEDURES": "Ulubione procedury",
        "PREVIOUS_MEDICAL_PROCEDURES": "Poprzednie procedury",
        "NO_FAVORITE_MEDICAL_PROCEDURES": "Brak ulubionych procedur",
        "NO_FAVORITE_MEDICAL_PROCEDURES_IN_HISTORY": "Brak procedur w historii",
        "SAVE_VISIT_DATA_AND_LEAVE": "Zapisz tymczasowo i wyjdź",
        "LEAVE": "Wyjdź",
        "FILL_DATA_FROM_VISITS": "Wypełnij dane z wizyt",
        "CANCEL_VISIT": "Odwołaj",
        "CANCEL_VISIT_CONFIRMATION": "Czy na pewno chcesz anulować wizytę?",
        "UNFINISHED_VISITS": "Wizyty niezakończone",
        "VISIT_DATE": "Data wizyty",
        "VISIT_STATUS_TYPE": "Status wizyty",
        "VISIT_ACTIONS": "Akcje",
        "FIRST_AND_LAST_PATIENT_NAME": "Imię i nazwisko",
        "GUARDIAN_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć opiekuna?",
        "NO_RESULT_FOR_THIS_QUERY": "Brak wyników dla tego zapytania",
        "APPOINTMENT_TIME": "Godzina przyjęcia",
        "FIRST_AND_LAST_NAME": "Imię i nazwisko",
        "CONTACT_PHONE": "Telefon kontaktowy",
        "PESEL": "PESEL",
        "MOTHER_PESEL": "PESEL opiekuna prawnego",
        "OTHER": "Inne",
        "ACTIONS": "Akcje",
        "EMPTY_LABORATORY_TEST_CATEGORY_DELETE_CONFIRMATION": "Uwaga! Czy na pewno chcesz usunąć kategorię?",
        "LABORATORY_TEST_CATEGORY_DELETE_CONFIRMATION": "Uwaga! Kategoria zawiera w sobie badania. Czy na pewno chcesz ją usunąć?",
        "VISIT_SAVE_AND_LEAVE_CONFIRMATION": "Zawieszając wizytę utracisz możliwość edycji aktualnie wystawionych dokumentów.\nCzy na pewno chcesz zawiesić wizytę?",
        "CREATE_DOCUMENT": "Wystaw dokument",
        "INSURANCE_STATEMENT_N_9": "Zaświadczenie o stanie zdrowia (druk N9)",
        "INSURANCE_STATEMENT_N_14": "Zaświadczenie o stanie zdrowia (druk N14)",
        "ABLE_TO_ATTEND_EXAMINATION": "Zdolny do odbycia podróży",
        "UNABLE_TO_ATTEND_EXAMINATION": "Niezdolny do odbycia podróży",
        "DISABLE_REASON": "Z powodu",
        "INSURANCE_STATEMENT_TREATMENT_DESCRIPTION": "Opis przebiegu choroby i dotychczasowego leczenia",
        "INSURANCE_STATEMENT_TREATMENT_DESCRIPTION_ADDITIONAL_INFO": "Należy uwzględnić od kiedy (data, okres) i z jakiego powodu prowadzono leczenie, pobyty w szpitalu, sanatorium, ośrodku rehabilitacji (okres, nazwa zakładu), dłuższe okresy czasowej niezdolności do pracy",
        "INSURANCE_STATEMENT_ADDITIONAL_RESULTS_AND_CONCLUSIONS": "Wyniki badań pomocniczych",
        "INSURANCE_STATEMENT_PROGNOSTICS": "Ocena wyników dotychczasowego leczenia i rokowanie",
        "INSURANCE_STATEMENT_PROGNOSTICS_ADDITIONAL_INFO": "Należy określić obecny stan zdrowia, prognozę przebiegu choroby, wskazania odnośnie dalszego leczenia i rehabilitacji",
        "INSURED_IS": "Ubezpieczony(a) jest",
        "PICK_OFFERS": "Wybierz badania",
        "PICK_RESOURCE": "Wybierz placówkę",
        "DELEGATION": "Zlecenie",
        "NO_RESULTS": "Brak wyników",
        "OFFERS_LIST": "Lista badań",
        "ADD_AT_LEAST_ONE_OFFER": "Dodaj co najmniej jedno badanie",
        "ALAB_DELEGATION": "Zlecenie ALAB",
        "ATTACHMENTS": "Załączniki",
        "DELEGATE_OFFERS": "Zleć badania",
        "PRINT_AND_DELEGATE": "Zleć i drukuj",
        "ALAB_LABORATORY_TEST": "Badanie laboratoryjne ALAB",
        "DESCRIBE_LABORATORY_TEST_RESULTS": "Opisz wyniki",
        "MEEDY_OFFERS": "Badania",
        "MEEDY_RESOURCE": "Placówka",
        "ENCLOSE_SIGNED_RECEIPT": "Załącz podpisane pokwitowanie",
        "DELEGATE": "Zleć",
        "NFZ": "NFZ",
        "PRIVATE": "Prywatna",
        "NEW_PATIENT": "Nowy pacjent",
        "STANDARD": "Standardowa",
        "PRESCRIPTION_2": "Recepturowa",
        "PRESCRIPTION_VISIT": "Wizyta recepturowa",
        "PAYU_PAYMENT": "Płatność PayU"
      }
    },
    "ENUM": {
      "VISIT_TYPE": {
        "GYNECOLOGICAL" : "Ginekologiczna",
        "CARDIOLOGICAL" : "Kardiologiczna",
        "INTERN": "Internistyczna",
        "LARYNGOLOGICAL": "Laryngologiczna",
        "NEUROLOGICAL": "Neurologiczna",
        "OPTHALMOLOGIC": "Okulistyczna",
        "ONCOLOGIC": "Onkologiczna",
        "ORTOPEDIC": "Ortopedyczna",
        "VIDEOCONSULTATION": "Wideokonsultacja",
        "ICF": "Wizyta ICF"
      },
      "VISIT_STATUS": {
        "PLANNED" : "Zaplanowana",
        "IN_PROGRESS": "W trakcie",
        "COMPLETED": "Zakończona",
        "CANCELED" : "Anulowana",
        "SUSPENDED": "Do uzupełnienia"
      },
      "MEDICAL_INDICATION": {
        "CAN_WALK": "Może chodzić",
        "SHOULD_LIE": "Powinien leżeć"
      },
      "LABORATORY_TEST_RESULT_TYPE" : {
        "RTG": "RTG",
        "USG": "USG",
        "MRI": "MRI",
        "TK": "TK",
        "LABORATORY_TEST" : "Badania laboratoryjne",
        "OTHER": "Inne"
      },
      "IDENTIFIER_TYPE" : {
        "PESEL": "PESEL",
        "MOTHER_PESEL": "PESEL opiekuna prawnego",
        "OTHER": "Identyfikator (inny)"
      }
    }
  }
});


